import { Component } from '@angular/core';

@Component({
  selector: 'app-availability-help',
  templateUrl: 'availability-help.component.html',
  styleUrls: ['availability-help.component.scss'],
})
export class AvailabilityHelpComponent {
  constructor() {}

  dialogVisible = false;

  showDialog() {
    this.dialogVisible = true;
  }

  onVisibilityChanged(status: any) {
    this.dialogVisible = status;
  }
}
